"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.storeDataChunksDeclaration = exports.StoreDataChunksResponse = exports.StoreDataChunksRequest = void 0;
const endpoints_1 = require("@moojo/endpoints");
const zod_1 = require("zod");
const data_chunk_1 = require("./data-chunk");
const data_chunk_receipt_1 = require("./data-chunk-receipt");
exports.StoreDataChunksRequest = zod_1.z.object({
    chunks: zod_1.z
        .object({
        id: zod_1.z.string(),
        chunk: data_chunk_1.DataChunk,
    })
        .array(),
});
exports.StoreDataChunksResponse = zod_1.z.object({
    successfulChunks: zod_1.z
        .object({
        id: zod_1.z.string(),
        receipt: data_chunk_receipt_1.DataChunkReceipt,
    })
        .array(),
    failedChunks: zod_1.z.object({ id: zod_1.z.string(), error: zod_1.z.string() }).array(),
    uploadedBytes: zod_1.z.number(),
});
exports.storeDataChunksDeclaration = (0, endpoints_1.endpointDeclaration)(exports.StoreDataChunksRequest, exports.StoreDataChunksResponse);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RvcmUtZGF0YS1jaHVua3MtYXBpLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3N0b3JlLWRhdGEtY2h1bmtzLWFwaS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxnREFBc0Q7QUFDdEQsNkJBQXVCO0FBRXZCLDZDQUF3QztBQUN4Qyw2REFBdUQ7QUFFMUMsUUFBQSxzQkFBc0IsR0FBRyxPQUFDLENBQUMsTUFBTSxDQUFDO0lBQzdDLE1BQU0sRUFBRSxPQUFDO1NBQ04sTUFBTSxDQUFDO1FBQ04sRUFBRSxFQUFFLE9BQUMsQ0FBQyxNQUFNLEVBQUU7UUFDZCxLQUFLLEVBQUUsc0JBQVM7S0FDakIsQ0FBQztTQUNELEtBQUssRUFBRTtDQUNYLENBQUMsQ0FBQTtBQUdXLFFBQUEsdUJBQXVCLEdBQUcsT0FBQyxDQUFDLE1BQU0sQ0FBQztJQUM5QyxnQkFBZ0IsRUFBRSxPQUFDO1NBQ2hCLE1BQU0sQ0FBQztRQUNOLEVBQUUsRUFBRSxPQUFDLENBQUMsTUFBTSxFQUFFO1FBQ2QsT0FBTyxFQUFFLHFDQUFnQjtLQUMxQixDQUFDO1NBQ0QsS0FBSyxFQUFFO0lBQ1YsWUFBWSxFQUFFLE9BQUMsQ0FBQyxNQUFNLENBQUMsRUFBRSxFQUFFLEVBQUUsT0FBQyxDQUFDLE1BQU0sRUFBRSxFQUFFLEtBQUssRUFBRSxPQUFDLENBQUMsTUFBTSxFQUFFLEVBQUUsQ0FBQyxDQUFDLEtBQUssRUFBRTtJQUNyRSxhQUFhLEVBQUUsT0FBQyxDQUFDLE1BQU0sRUFBRTtDQUMxQixDQUFDLENBQUE7QUFHVyxRQUFBLDBCQUEwQixHQUFHLElBQUEsK0JBQW1CLEVBQUMsOEJBQXNCLEVBQUUsK0JBQXVCLENBQUMsQ0FBQSJ9